export default __webpack_public_path__ + "locales/fr/DeleteDialog.json?hash=1a1a3f7f026f6fe799de92a73e15843d";